<template>
  <v-container fluid grid-list-md>
    <plan-eligibility
      :eligibility="eligibility"
      @valid="$emit('valid', $event)"
      :hasDependants="hasDependants"
      :planCoverageCommencementRules="eligibility.CoverageCommencementRules"
      @update-plan-coverage-commencement-rules="
        $emit('update-plan-coverage-commencement-rules', $event)
      "
      :employers="employers"
      :hasClasses="hasClasses"
      :hasDefaultCoverage="selectedFields.filter(o=>o.Key==='DefaultCoverageStatus').length > 0"
      :classesArray="classesArray"
      :memberGroups="memberGroups"
      :logicalExpressionsHeaders="logicalExpressionsHeaders"
      :logicalExpressionsFields="logicalExpressionsFields"
      :memberCoverageEligibilityRules="eligibility.MemberCoverageEligibilityRules"
      @update-member-coverage-eligibility-rules="
        $emit('update-member-coverage-eligibility-rules', $event)
      "
      :memberLogicalExpressionsHeaders="memberLogicalExpressionsHeaders"
      :memberLogicalExpressionsFields="memberLogicalExpressionsFields"
      :selectedFields="selectedFields"
      :eligibilityHourBankSettings="eligibilityHourBankSettings"
      @update-eligibility-hour-bank-settings="$emit('update-eligibility-hour-bank-settings', $event)"
      :generalSettings="generalSettings"
      :selfPaymentSettings="selfPaymentSettings"
      @update-self-payment-settings="$emit('update-self-payment-settings', $event)"
    />
    <!-- <member-eligibility
      :effectiveDate="effectiveDate"
      :memberGroups="memberGroups"
      :eligibilityPeriodRules="eligibilityPeriodRules"
      :classesArray="classesArray"
      :selectedFields="selectedFields"
      @update-eligibility-period-rules="
        $emit('update-eligibility-period-rules', $event)
      "
      :planIdentityId="planIdentityId"
      :disabled="disabled"
    /> -->
    <activity-status
      :effectiveDate="effectiveDate"
      :coverage="coverage"
      :activityStatusRules="eligibility.ActivityStatusRules"
      @update-activity-status="$emit('update-activity-status', $event)"
      :planIdentityId="planIdentityId"
      :disabled="disabled"
    />
    <benefit-rules
      :effectiveDate="effectiveDate"
      :hasClasses="hasClasses"
      :classesArray="classesArray"
      :coverage="coverage"
      :benefitRules="eligibility.BenefitRules"
      @update-benefit-rules="$emit('update-benefit-rules', $event)"
      :disabled="disabled"
    />
    <!-- <sick-payment-bank-eligibility
      v-if="sickPaymentBank"
      :eligibility="eligibility.SickPaymentBankEligibility"
      @valid="$emit('valid', $event)"
    /> -->
  </v-container>
</template>

<script>
// import MemberEligibility from "@/components/PlanBuilder/MemberEligibility.vue";
import PlanEligibility from "@/components/PlanBuilder/PlanEligibility.vue";
import ActivityStatus from "@/components/PlanBuilder/ActivityStatus.vue";
import BenefitRules from "@/components/PlanBuilder/BenefitRules.vue";
import SickPaymentBankEligibility from './SickPaymentBankEligibility.vue';

export default {
  components: {
    // MemberEligibility,
    PlanEligibility,
    ActivityStatus,
    BenefitRules,
    SickPaymentBankEligibility,
  },
  props: [
    "eligibility",
    "coverage",
    "memberGroups",
    "effectiveDate",
    "classesArray",
    "hasClasses",
    "planIdentityId",
    "disabled",
    "selectedFields",
    "employers",
    "logicalExpressionsHeaders",
    "logicalExpressionsFields",
    "memberLogicalExpressionsHeaders",
    "memberLogicalExpressionsFields",
    "sickPaymentBank",
    "eligibilityHourBankSettings",
    "generalSettings",
    "selfPaymentSettings"
  ],
  computed:{
    hasDependants() {
      return this.selectedFields.filter(o=>o.Key === "CurrentDependants").length > 0;
    }
  },
  mounted() {},
  data() {
    return {};
  },
  watch: {},
};
</script>
